export default [
  // 数据源
  {
    path: "dataSource",
    name: { list: ["溯源中心", "数据源", "数据源管理", "数据源管理"] },
    component: () => import("@/views/traceability/dataSource.vue"),
  },
  {
    path: "dataInterface",
    name: { list: ["溯源中心", "数据源", "数据源管理", "API服务管理"] },
    component: () => import("@/views/traceability/dataInterface.vue"),
  },
  {
    path: "dataFileImport",
    name: { list: ["溯源中心", "数据源", "数据源管理", "文件导入管理"] },
    component: () => import("@/views/traceability/dataFileImport.vue"),
  },
  // 数据采集
  {
    path: "dataImport",
    name: { list: ["溯源中心", "数据采集", "采集数据管理", "数据导入"] },
    component: () => import("@/views/traceability/dataImport.vue"),
  },
  {
    path: "dataCollect",
    name: { list: ["溯源中心", "数据采集", "采集数据管理", "采集数据管理"] },
    component: () => import("@/views/traceability/dataCollect.vue"),
  },
  {
    path: "dataDetails",
    name: {
      list: [
        "溯源中心",
        "数据采集",
        "采集数据管理",
        "采集数据管理",
        "查看采集数据",
      ],
    },
    component: () => import("@/views/traceability/dataDetails.vue"),
  },
  {
    path: "dataCallRecord",
    name: { list: ["溯源中心", "数据采集", "采集日志", "API调用记录"] },
    component: () => import("@/views/traceability/dataCallRecord.vue"),
  },
  {
    path: "dataFileRecord",
    name: { list: ["溯源中心", "数据采集", "采集日志", "文件导入记录"] },
    component: () => import("@/views/traceability/dataFileRecord.vue"),
  },
];
